import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const notification = this.injector.get(NotificationService);
    
    // Log full error to console for debugging
    console.error('Captured by GlobalErrorHandler:', error);

    // Prepare user-friendly message
    let userMessage = '';
    
    if (error.status === 401 || error.status === 403) {
      userMessage = 'You do not have permission to perform this action.';
    } else if (error.message && typeof error.message === 'string') {
      // Avoid raw stack traces, but messages from known services can be helpful
      userMessage = error.message.includes('Firebase') ? 'Connection error. Please check your internet.' : userMessage;
    }

    // Show Toast notification using your notification service
    userMessage && notification.show(userMessage, 'error');

    // Optional: Log to external service (e.g. Sentry/Raygun) in production
    // if (environment.production) { ... }
  }
}
